import React from 'react';
const stats = [['500+', 'Entraîneurs'], ['6 + 5', 'Modules & Bonus'], ['4.9/5', 'Note moyenne'], ['Mondial', 'Utilisé partout']];
const notes = [['“J’ai planifié toute ma saison en une seule soirée. Chaque séance a désormais un objectif clair.”', 'Jean M.', 'Marseille, France'], ['“Les progressions sont logiques et les joueurs sentent qu’ils s’améliorent vraiment.”', 'Coach David', 'Lyon, France'], ['“Tout ce dont j’ai besoin est là. Plus besoin de passer des heures à chercher des exercices.”', 'Priya T.', 'Bordeaux, France']];
export function ProofSection() {
  return <section className="bg-[#0A0A0A] px-5 pb-16" data-id="element-179">
      <div className="mx-auto max-w-6xl" data-id="element-180">
        <div className="grid grid-cols-2 border border-[#d4af37]/25 bg-[#16161F] sm:grid-cols-4" data-id="element-181">
          {stats.map(([value, label]) => <div key={label} className="border-b border-r border-[#d4af37]/15 px-4 py-6 text-center last:border-r-0 sm:border-b-0" data-id="element-182">
              <p className="font-display text-4xl font-bold uppercase text-[#d4af37] sm:text-5xl" data-id="element-183">
                {value}
              </p>
              <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-[#B0B0C0]" data-id="element-184">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-185">
          {notes.map(([quote, name, location]) => <figure key={name} className="flex flex-col border border-[#E5E5EA] bg-white p-6" data-id="element-186">
              <div className="mb-4 text-[#d4af37]" aria-label="5 étoiles sur 5" data-id="element-187">
                ★★★★★
              </div>
              <blockquote className="flex-1 text-sm font-medium italic leading-relaxed text-[#0A0A0A]" data-id="element-188">
                {quote}
              </blockquote>
              <figcaption className="mt-5 border-t border-[#E5E5EA] pt-4 text-sm font-bold text-[#0A0A0A]" data-id="element-189">
                {name}
                <span className="ml-2 text-xs font-medium text-[#5A5A66]" data-id="element-190">
                  {location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}